export default __webpack_public_path__ + "static/media/stargrills_1.10e69b24.jpg";